import { render } from "./WorskpaceGroupHeader.vue?vue&type=template&id=09f46e64"
import script from "./WorskpaceGroupHeader.vue?vue&type=script&lang=js"
export * from "./WorskpaceGroupHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__